export default "__VITE_ASSET__CHMWIrhq__"